type Variant = "elevation" | "plan" | "section";

/**
 * Lightweight, decorative architectural line work. The drawing is inline SVG
 * so it adds no network request, inherits the current ink colour and can be
 * removed entirely from the accessibility tree.
 */
export function ArchitecturalBackdrop({
  variant = "elevation",
  className = ""
}: {
  variant?: Variant;
  className?: string;
}) {
  return (
    <div
      className={`architectural-backdrop architectural-${variant} ${className}`.trim()}
      aria-hidden="true"
    >
      {variant === "elevation" && <Elevation />}
      {variant === "plan" && <Plan />}
      {variant === "section" && <Section />}
    </div>
  );
}

function Elevation() {
  return (
    <svg viewBox="0 0 720 560" fill="none" stroke="currentColor" strokeWidth="1">
      <g opacity="0.9">
        <path d="M56 516V278L206 194l150 84v238" />
        <path d="M356 516V324l120-67 120 67v192" />
        <path d="M206 194v322M56 278h300M356 324h240" />
        <path d="M150 166v-28h112v28M182 138v-18h48v18" />
        <path d="M88 310h72v90H88zM118 310v90M88 355h72" />
        <path d="M206 322h72v74h-72zM232 322v74M206 359h72" />
        <path d="M388 344h64v70h-64zM420 344v70M388 379h64" />
        <path d="M500 344h64v70h-64zM532 344v70M500 379h64" />
        <path d="M430 516V422h72v94M466 422v94" />
        <path d="M604 408h56v108h-56zM604 438h56" />
        <path d="M18 516h684" />
      </g>
      <g opacity="0.52">
        <path d="M34 538h652" strokeDasharray="1 9" />
        <path d="M34 528v20M206 528v20M356 528v20M686 528v20" />
        <path d="M18 278v238M206 166v-46M476 324v192" strokeDasharray="1 7" />
        <path d="M12 194h18M188 194h18M470 324h18" />
        <path d="M632 370v32M632 386h18M632 378h-18" />
        <path d="M70 54h90M70 44v20M160 44v20" />
      </g>
    </svg>
  );
}

function Plan() {
  return (
    <svg viewBox="0 0 760 520" fill="none" stroke="currentColor" strokeWidth="1">
      <g opacity="0.86">
        <path d="M50 60h300v190H50zM350 60h350v130H350z" />
        <path d="M50 250h240v210H50zM290 250h190v210H290z" />
        <path d="M480 190h220v270H480zM290 190h190v60" />
        <path d="M290 370h190M350 250v210M560 190v270" />
        <path d="M250 250a40 40 0 0 1 40 40M560 310a36 36 0 0 1 36 36" />
        <path d="M90 100h90v56H90zM390 100h120v56H390z" />
        <path d="M90 290h70v86H90zM320 290h64v70h-64z" />
        <path d="M510 228h86v74h-86zM626 228h40v74h-40z" />
      </g>
      <g opacity="0.48">
        <path d="M50 500h650" strokeDasharray="1 9" />
        <path d="M50 490v20M350 490v20M700 490v20" />
        <path d="M32 60v450M18 60h28M18 250h28M18 460h28" strokeDasharray="1 7" />
        <path d="M340 34v22M340 45h-16M700 34v22M700 45h-16" />
        <circle cx="670" cy="46" r="10" />
        <path d="M670 36v20M660 46h20" />
      </g>
    </svg>
  );
}

function Section() {
  return (
    <svg viewBox="0 0 800 280" fill="none" stroke="currentColor" strokeWidth="1">
      <path d="M0 246h800" />
      <path d="M60 246V92h200v154M260 246V144h200v102M460 246V92h280v154" />
      <path d="M60 118h200M460 118h280M60 210h200M460 210h280" />
      <path d="M260 144h200M260 246v-34h200v34" />
      <g opacity="0.55">
        <path d="M20 266h760" strokeDasharray="1 10" />
        <path d="M60 258v16M260 258v16M460 258v16M740 258v16" />
        <path d="M100 118v-26M220 118v-26M500 118v-26M700 118v-26" strokeDasharray="1 6" />
        <path d="M110 92h80M110 80v24M190 80v24" />
        <path d="M490 92h90M490 80v24M580 80v24" />
      </g>
    </svg>
  );
}
